import { postContent } from './api-helper';

const radarLiveUrl = `${process.env.REACT_APP_SPN_RADAR_LIVE_API}/price`;

export const getRadarLivePricing = async (content) => postContent(radarLiveUrl, content);
